import Error from "./emptyType4";

export { Error };
export default Error;
